import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import Clevertap from 'analytics'
import { Spacer, Button, Checkbox } from '@cleartrip/bento'
import ModalHeader from '../UserProfileModalHeader'
import { ProfileDataContext } from 'context/flights/results'
import { UserProfileContext } from 'context/itinerary'
import { useLocation } from 'react-router'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { ReactComponent as SuperCoins } from 'assets/icons/SuperCoins.svg'
import { ReactComponent as SellDesign } from 'assets/icons/sell.svg'
import { ReactComponent as AccountCircleDesign } from 'assets/icons/account_circle.svg'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import OtpBox from './otpBox'
import { getCookie, isEmpty } from 'utils/browserHelper'
import { checkForLinkingNudge, getLinkedEmailsList, verifyOtpForSignIn, sendOtpForSignIn, getAbTestConfig } from 'api/flights/results'
import { errorConfig } from './errorConfig'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { resolveKeysInObjectsArrays } from 'utils/browserHelper'
import { fetchUserProfileData } from 'api/flights/itinerary'
import ModalHeaderNew from '../UserProfileModalHeaderNew'
import { ReactComponent as WalletLogin } from 'assets/icons/WalletLogin.svg'
import { ReactComponent as OffersLogin } from 'assets/icons/OffersLogin.svg'
import BannerSlider from 'components/BannerSlider'
import { OtpBlock } from 'lib/Login/OtpBlock'
import logError from 'utils/logError'
const verifyMobileNumberNew = ({
    toggle,
    mobileNumber,
    defaultCountryCode,
    setPageName,
    checkboxClass,
    rememberCheckedStatus,
    setRememberCheckedStatus,
    checkBoxTextClass,
    redirectToPage,
    email,
    setMobileNumber,
    toggleModalAndClosePage,
    setLinkedEmails,
    setUserSignedIn,
    showCloseButton,
    setLoginCase,
    hideLoginBanner,
    superCoinAddNumber,
    superCoinLogin,
    abLogin = 'a',
    abInline = 'a'
}) => {
    const [userProfile, setUserProfile] = useContext(ProfileDataContext)
    const [userData, setUserData] = useContext(UserProfileContext)
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }

    const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]
    const location = useLocation()
    let locationArray = location.pathname.split('/')
    let itineraryId = locationArray[locationArray.length - 2]

    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
    const [otpValidationError, setOtpValidationError] = useState('')
    const [apiError, setApiError] = useState('')
    const [countDown, setCountDown] = useState(30)
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const [isLoading, setIsLoading] = useState(false)
    const [elementInFocus, setElemntInFocus] = useState(0)
    const bannerAnimationRef = useRef()
    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })

    const animatedClassNew = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'pxNew-8': 'pxNew-8'
    })

    const getOtpValue = () => {
        const otp = otpDigits.join('')
        return otp
    }

    let errorInfo = 'fs-inherit c-inherit pl-2'
    const disabled = getOtpValue().length != 6
    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]
    const otpString = otpDigits.join('')
    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()

    useEffect(() => {
        refs[0]?.current?.focus()
        countDownHandler(30)
        ClevertapEvent({
            actionName: 'login_OTP_modal_opened',
            actionType: 'Button',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath
        })
    }, [])

    useEffect(() => {
        if (otpString.length === 4) {
            verifyOtp()
        }
    }, [otpString.length])

    const setElementInFocus = index => {
        setElemntInFocus(index)
        refs[index]?.current?.focus()
    }

    const countDownHandler = (countDown, lastCountdown = false) => {
        if (countDown === 0) {
            return
        } else {
            if (countDown === 1) {
                if (lastCountdown) {
                    setRetriesLeft(-1)
                }
            }
            const updatedCountDown = countDown - 1
            setCountDown(updatedCountDown)
            setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
        }
    }

    const getUserProfileData = async () => {
        try {
            let UserProfileResponse = await fetchUserProfileData(itineraryId)
            setUserData(UserProfileResponse.data)
        } catch (e) {
            logError(e)
            console.log('User Profile api error', e)
        }
    }

    const clearOtp = () => {
        const emptyOtpDigits = ['', '', '', '', '', '']
        setOtpDigits(emptyOtpDigits)
        refs[0]?.current?.focus()
    }
    const resendOtp = async () => {
        ClevertapEvent({
            actionName: 'resend_otp_clicked',
            platform: 'desktop',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',
            is_logged_in: 'no',
            domainName: 'www.cleartrip.com'
        })
        // send otp logic
        //set retries = -1 if limit exceed
        setApiError('')
        if (countDown !== 0 || retriesLeft <= 0) {
            return
        } else {
            try {
                const payload = {
                    type: 'MOBILE',
                    value: mobileNumber,
                    countryCode: defaultCountryCode,
                    action: email ? 'UPDATE_MOBILE' : 'SIGNIN'
                }
                const response = await sendOtpForSignIn(payload)
                const { status, data, error } = response || {}
                if (status === 202) {
                    const { action } = data || {}
                    clearOtp()
                    countDownHandler(30)
                } else {
                    const { response = { data: {} } } = error || {}
                    const { data = {} } = response
                    const { message } = data
                    const err = errorConfig[message] || errorConfig.default
                    if (isEmpty(email)) {
                        ClevertapEvent({
                            actionName: 'Error_Occured_Login_modal',
                            actionType: 'Button',
                            page:
                                pagePath === 'results'
                                    ? 'SRP'
                                    : isEmpty(pagePath) || isHiFiveFlow
                                    ? 'HP'
                                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                    ? 'Itinerary'
                                    : 'Confirmation_Page',

                            currentPage: pagePath,
                            error_type:
                                message === 'OTP_SEND_LIMIT_EXCEEDED' ? 'OTP limit exceeded' : 'OTP generation failed'
                        })
                    }
                    setApiError(err)
                    if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
                        setRetriesLeft(-1)
                    }
                }
            } catch (e) {
                console.log('Resend api error', e)
            }
        }
    }

    const otpChangeHandler = (event, index) => {
        setApiError('')
        const value = event.nativeEvent.data || event.target.value
        const numberValue = Number(value)
        if (value === ' ') return
        if (value === '') {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = ''
            setOtpDigits(otpFieldValues)
            return
        }
        if (numberValue >= 0 && Number.isInteger(numberValue)) {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = value % 10
            setOtpDigits(otpFieldValues)
            setElementInFocus(index + 1)
            return
        }
    }
    const otpCursorHandler = (event, index) => {
        if (event.keyCode === 37) {
            setElementInFocus(index - 1)
        }
        if (event.keyCode === 39) {
            setElementInFocus(index + 1)
        }
        if (event.keyCode === 8) {
            if (event.target.value === '') {
                const otpFieldValues = [...otpDigits]
                const indexToRemove = index - 1
                if (indexToRemove < 0) {
                    return
                }
                otpFieldValues[indexToRemove] = ''
                setOtpDigits(otpFieldValues)
                setElementInFocus(indexToRemove)
            } else {
                const otpFieldValues = [...otpDigits]
                otpFieldValues[index] = ''
                setOtpDigits(otpFieldValues)
            }
        }
    }

    const verifyOtp = async () => {
        setOtpValidationError('')
        dataLayerGA({ section: 'Login' }, 'login_verify_clicked')
        ClevertapEvent({
            actionName: 'Entered_OTP_on_login_modal',
            actionType: 'Button',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath
        })
        setIsLoading(true)
        const otp = getOtpValue()
        const payload = {
            type: 'MOBILE',
            value: mobileNumber,
            countryCode: defaultCountryCode,
            action: email ? 'UPDATE_MOBILE' : 'SIGNIN',
            otp
        }
        let customHeader = {}
        if (isHiFiveFlow) {
            const ref = pathname[2] || ''
            customHeader = {
                ...customHeader,
                'referral-link': `https://${process.env.NODE_ENV === 'production' ? 'm' : 'qa2m'}.cltp.in/ref/${ref}`
            }
        }
        try {
            const response = await verifyOtpForSignIn(payload, customHeader)
            const { status, data, error } = response || {}

            if (status === 200) {
                const { action } = data || {}
                if (superCoinAddNumber || superCoinLogin) {
                    Clevertap.event('Otp_Verification', {
                        action_name: superCoinAddNumber ? 'phone verification' : 'Login verification',
                        status: 'successful verification',
                        is_logged_in: 'yes'
                    })
                }
                if (action === 'SIGNIN') {
                    let popupLogin = false
                    const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))
                    if (pagePath === 'itinerary' && obj?.flightIternary) {
                        popupLogin = true
                    } else if (pagePath === undefined && obj?.flightHome) {
                        popupLogin = true
                    }
                    ClevertapEvent({
                        actionName: 'Login_succesful',
                        actionType: 'Button',
                        action: 'signin',
                        login_cookie: abInline,
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        login_type: 'Mobile',
                        first_time_login: 'No',
                        auto_pop: popupLogin,
                        keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
                    })
                    if (pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary') {
                        const resp = await getUserProfileData()
                        setUserSignedIn(true)
                        toggleModalAndClosePage(false)
                    } else {
                        setUserSignedIn(true)
                        if (isHiFiveFlow) {
                            setLoginCase(action)
                            toggleModalAndClosePage(false)
                        } else {
                            toggleModalAndClosePage()
                        }
                    }

                    // const res = await checkForLinkingNudge()
                    // const { status, data } = res || {}
                    // if (status === 200) {
                    // if (data.action) {
                    //     setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
                    // } else {

                    // }
                    // } else {
                    //     const { message } = data
                    //     const error = errorConfig[message] || errorConfig.default
                    //     setApiError(error)
                    // }
                }
                if (action === 'SIGNUP') {
                    let popupLogin = false
                    const obj = JSON.parse(window.sessionStorage.getItem('loginPopup'))

                    if (pagePath === 'itinerary' && obj?.flightIternary) {
                        popupLogin = true
                    } else if (pagePath === undefined && obj?.flightHome) {
                        popupLogin = true
                    }
                    ClevertapEvent({
                        actionName: 'Login_succesful',
                        actionType: 'Button',
                        action: 'signup',
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        login_type: 'Mobile',
                        first_time_login: 'Yes',
                        auto_pop: popupLogin,
                        keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
                    })
                    setUserSignedIn(true)
                    if (isHiFiveFlow) {
                        Clevertap.event('New_signup', {
                            signup_source: 'Hi5_link'
                        })
                        setLoginCase(action)
                    }
                    if (pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary') {
                        const resp = await getUserProfileData()
                        toggleModalAndClosePage(false)
                    } else {
                        const payload = {
                            mobileNumber,
                            countryCode: defaultCountryCode
                        }
                        const res = await getLinkedEmailsList(payload)
                        const { status, data, error } = res || {}
                        if (status === 200) {
                            ClevertapEvent({
                                action_name: 'existing_email_modal_opened',
                                action: 'signup',
                                page:
                                    pagePath === 'results'
                                        ? 'SRP'
                                        : isEmpty(pagePath) || isHiFiveFlow
                                        ? 'HP'
                                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                        ? 'Itinerary'
                                        : 'Confirmation_Page',
                                is_logged_in: 'yes'
                            })
                            setLinkedEmails(data)
                            setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
                            // }
                            //TODO when fk apis are ready
                            // else {
                            //     const res = await checkForLinkingNudge()
                            //     const { status, data } = res || {}
                            //     if (status === 200) {
                            //         if (data.action) {
                            //             setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
                            //         } else {
                            //             setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
                            //         }
                            //     } else {
                            //         const { message } = data
                            //         const error = errorConfig[message] || errorConfig.default
                            //         setApiError(error)
                            //     }
                            // }
                        } else {
                            const { response = { data: {} } } = error || {}
                            const { data = {} } = response
                            const { message } = data
                            const err = errorConfig[message] || errorConfig.default
                            // setApiError(err)
                            setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
                        }
                    }
                }
                // if email present then to link mobile to fk
                if (action === 'UPDATE_MOBILE') {
                    // const res = await checkForLinkingNudge()
                    // const { status, data } = res || {}
                    // if (status === 200) {
                    //     if (data.action) {
                    //         setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
                    //     } else {
                    toggle()
                    setUserProfile({
                        ...userProfile,
                        mobile: mobileNumber,
                        countryCode: defaultCountryCode,
                        mobileVerified: true
                    })

                    //     }
                    // } else {
                    //     const { message } = data
                    //     const error = errorConfig[message] || errorConfig.default
                    //     setApiError(error)
                    // }
                }
            } else {
                const { response = { data: {} } } = error || {}
                const { data = {} } = response
                const { message } = data
                const errRes = errorConfig[message] || errorConfig.default

                if (isEmpty(email)) {
                    ClevertapEvent({
                        actionName: 'Error_Occured_Login_modal',
                        actionType: 'Button',
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        error_type: 'OTP verification failed'
                    })
                }
                if (message === 'INVALID_OTP') {
                    if (superCoinAddNumber || superCoinLogin) {
                        Clevertap.event('Air_UI_Action', {
                            action_name: superCoinAddNumber ? 'phone verification' : 'Login verification',
                            status: 'incorrect otp',
                            is_logged_in: 'no'
                        })
                    }
                    setOtpValidationError(errRes)
                } else {
                    setApiError(errRes)
                }
            }
        } catch (e) {
            console.log('verify Otp api error', e)
        }
        setIsLoading(false)
    }

    const otpBlock = [1, 2, 3, 4].map((element, index) => {
        return (
            <OtpBox
                key={index}
                onKeyDown={e => otpCursorHandler(e, index)}
                onChange={e => otpChangeHandler(e, index)}
                onMouseDownCapture={() => {
                    setElementInFocus(index)
                }}
                ref={refs[index]}
                value={otpDigits[index]}
                style={{
                    margin: `11px ${index === 5 ? '0px' : '10px'} 14px 0px`,
                    border: otpValidationError
                        ? ' solid 1px #ff3c2b'
                        : refs[index]?.current === document.activeElement
                        ? 'solid 1px #36c'
                        : 'solid 1px #e6e6e6'
                }}
            />
        )
    })

    const handleBackButton = () => {
        setMobileNumber('')
        if (!hideLoginBanner) {
            if (isEmpty(email)) {
                setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)
            } else {
                setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
                setMobileNumber('')
            }
        } else {
            setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
            // setMobileNumber('')
        }
    }

    useEffect(() => {
        let OutsideClickHandler = event => {
            if (!bannerAnimationRef.current.contains(event.target)) {
                toggle()
            }
        }
        document.addEventListener('mousedown', OutsideClickHandler)
        return () => {
            document.removeEventListener('mousedown', OutsideClickHandler)
        }
    })


    useEffect(() => {
        if (otpValidationError) {
            clearOtp()
        }
    }, [otpValidationError])
    return (
        <>
            <div ref={bannerAnimationRef} className="d-flex">
                {(!hideLoginBanner) &&(
                    <div
                        className="o-hidden d-flex flex-column brLogin-4 mt-150"
                        style={{
                            width: '410px',
                            height: '437px'
                        }}
                    >
                        {abLogin === 'a' && <BannerSlider />}  
                        {abLogin === 'b' && <img src="https://fastui.cltpstatic.com/image/upload/f_auto,q_auto,w_410,h_437,dpr_2/offermgmt/bbdJson/Desktop_Banner.png" className="h-100" />}  
                        
                    </div>
                )}
                <div
                    className={'bg-white o-hidden d-flex flex-column brLoginNew-4 mt-150'}
                    style={{
                        width: '400px',
                        height: (hideLoginBanner) ? '440px' : '437px'
                    }}
                >
                    <div
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                if (!disabled) {
                                    verifyOtp()
                                }
                            }
                        }}
                        className={`${animatedClass} d-flex flex-1 flex-column`}
                    >
                        <ModalHeaderNew toggle={toggle} verifyCondition={true} showCloseButton={showCloseButton} />
                        <OfflineToast page={isEmpty(email) ? 'proceed' : 'verify mobile number'} />
                        {apiError && (
                            <>
                                <div
                                    style={{ marginBottom: '22px' }}
                                    className="py-3 px-2 flex flex-middle bg-error-600 c-white fs-2 br-4"
                                >
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span className={errorInfo}>{apiError}</span>
                                </div>
                            </>
                        )}

                        <div className="d-flex flex-column flex-between flex-1">
                            <div>
                                <div
                                    className={`c-pointer flex flex-middle mt-1 ${
                                        isLoading ? 'c-neutral-200' : 'c-secondary-500'
                                    } fs-3 fw-500`}
                                >
                                    <div style={{ marginLeft: '-2px', marginTop: '2px' }}>
                                        <ArrowLeft height={18} className="c-inherit" />
                                    </div>
                                    &nbsp;{' '}
                                    <span className="fs-2 fw-500" onClick={handleBackButton}>
                                        {'Change number'}
                                    </span>
                                </div>
                                <Spacer className="ptNew-18" />
                                <p className="fs-3 c-neutral-700">
                                    <span className="fs-3 c-neutral-700"> {'Enter OTP sent to the number '} </span>
                                    <span className="fs-3 c-neutral-700 fw-600">{`${defaultCountryCode} ${mobileNumber}`}</span>
                                </p>
                                {/* <div className="d-flex">{otpBlock}</div> */}
                                <OtpBlock mobileNumber={mobileNumber} 
                                    setApiError={setApiError}
                                    toggle={toggle}
                                    defaultCountryCode={defaultCountryCode}
                                    setPageName={setPageName}
                                    rememberCheckedStatus={rememberCheckedStatus}
                                    email={email}
                                    toggleModalAndClosePage={toggleModalAndClosePage}
                                    setLinkedEmails={setLinkedEmails}
                                    setUserSignedIn={setUserSignedIn}
                                    setLoginCase={setLoginCase}
                                    superCoinAddNumber={superCoinAddNumber}
                                    superCoinLogin={superCoinLogin}
                                    itineraryId={itineraryId}
                                    abLogin={abLogin}
                                    abInline={abInline}
                                    startCounter={true}
                                />
                                {/* {otpValidationError && (
                                    <div className="c-error-500 mb-3" style={{ marginTop: '-8px' }}>
                                        {otpValidationError}
                                    </div>
                                )} */}
                                {/* <div style={{ marginBottom: '29px' }}>
                                    <span className="fs-2 c-neutral-700">{"Haven't received OTP?"}</span>
                                    <span
                                        onClick={resendOtp}
                                        className={`fs-2 fw-500 ml-1 ${
                                            retriesLeft === -1
                                                ? 'c-neutral-200'
                                                : countDown !== 0
                                                ? `c-neutral-200`
                                                : isLoading
                                                ? 'c-neutral-200'
                                                : 'c-blue c-pointer'
                                        }`}
                                    >
                                        {retriesLeft === -1
                                            ? 'Resend'
                                            : countDown !== 0
                                            ? `Resend (${countDown}s)`
                                            : 'Resend'}
                                    </span>
                                </div> */}
                                {isEmpty(email) && (
                                    <Checkbox
                                        className={checkboxClass}
                                        checked={rememberCheckedStatus}
                                        onClick={() => setRememberCheckedStatus(!rememberCheckedStatus)}
                                    >
                                        <span className={checkBoxTextClass}>{'Keep me logged in'}</span>
                                    </Checkbox>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default verifyMobileNumberNew
